module.exports = __webpack_public_path__ + "/build/web/images/hero-matching-pillows.9aed392d1f72ec656171fc696c15a811.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-matching-pillows.jpg
// module id = 139
// module chunks = 13